exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "textarea[data-v-3b09013c]{border-radius:0;background-color:#fff;border:none;box-shadow:none}.video-js[data-v-3b09013c]{width:449px!important;height:268px}@media only screen and (max-width:768px){.video-js[data-v-3b09013c]{width:337px!important;height:253px}}", ""]);

// exports
